import { loadStripe } from '@stripe/stripe-js';
let stripePromise:any;
const getStripe = async (publicKey: string | undefined) => {
  if (!publicKey) return null
  if (!stripePromise) {
    stripePromise = await loadStripe(publicKey, {locale: 'en'});
  }
  return stripePromise;
};
export default getStripe;